import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import React, { useState, useRef, useCallback, useMemo } from "react";
import OAuth from "../../../../artist/components/OAuth";
import { Close } from "@mui/icons-material";
import FlatList from "flatlist-react/lib";
import ImageViewer from "../../../../components/ImageViewer";
import ImageUploadOptions from "../../../../components/ImageUploadOptions";
import PhotoSvgIcon from "../../../../assets/icons/imageButton";

const ImageSection = ({ images, onUpload, onRemove }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [imageViewIsOpen, setImageViewIsOpen] = useState(false);
  const selectedImageIndexRef = useRef(0);

  const handleImageOpen = useCallback((index) => {
    selectedImageIndexRef.current = index;
    setImageViewIsOpen(true);
  }, []);

  const handleUpload = useCallback(() => {
    setModalVisible(true);
  }, []);

  const AddPhotoComponent = () => {
    return (
      <Button
        onClick={handleUpload}
        className="flex flex-row gap-1 rounded-md justify-center items-center"
        sx={{
          border: "1px solid #E7EBF1",
          borderRadius: "8px",
          padding: "6px 12px",
          "&:hover": {
            backgroundColor: "transparent",
            border: "1px solid #E7EBF1",
          },
        }}
      >
        <PhotoSvgIcon />
        <p className="text-[#687382] font-[10px]">Upload Images</p>
      </Button>
    );
  };

  const renderItem = (item, index) => {
    return (
      <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
        <Button onClick={() => handleImageOpen(index)}>
          <OAuth
            component={
              <img
                src={URL.createObjectURL(item)}
                alt="Uploaded image"
                className="object-cover w-full aspect-square rounded"
              />
            }
          />
        </Button>
        <IconButton
          sx={{
            position: "absolute",
            top: 2,
            right: 2,
            background: "#F3F3F3",
            width: 22,
            height: 22,
            padding: "2px",
            zIndex: 10,
          }}
          size="small"
          onClick={() => onRemove(index)}
        >
          <Close sx={{ fontSize: "12px" }} />
        </IconButton>
      </Box>
    );
  };

  const ListEmpty = () => {
    return (
      <div className="text-center text-[16px] font-['Poppins-Medium']"></div>
    );
  };

  const RENDER_GALLERY = useMemo(
    () => (
      <Stack space={2}>
        <FlatList
          key={"REFERENCE-PHOTOS-LIST"}
          list={[...images]}
          renderItem={renderItem}
          displayGrid
          minColumnWidth="100px"
          gridGap="10px"
          renderWhenEmpty={ListEmpty}
        />
      </Stack>
    ),
    [images]
  );

  const IMAGE_VIEWER = useMemo(
    () => (
      <ImageViewer
        visible={imageViewIsOpen}
        onClose={setImageViewIsOpen?.bind(null, false)}
        imageList={images.map((a) => ({
          ...a,
          src: URL.createObjectURL(a),
        }))}
        selectedIndex={selectedImageIndexRef.current}
        styles={{
          root: { "--yarl__color_backdrop": "#28282890" },
          thumbnail: { border: 0, width: "fit-content" },
          thumbnailsTrack: { gap: "5px" },
        }}
      />
    ),
    [imageViewIsOpen]
  );

  return (
    <Box>
      <Typography variant="h6">Reference Photos</Typography>
      <Box flexGrow={1} mt={2}>
        {RENDER_GALLERY}
      </Box>
      <div className="mt-1">
        <AddPhotoComponent />
      </div>
      {IMAGE_VIEWER}
      <ImageUploadOptions
        allowMultiple
        open={modalVisible}
        onClose={setModalVisible?.bind(null, false)}
        title="You can select upto 5 images"
        onSubmit={onUpload}
      />
    </Box>
  );
};

export default ImageSection;
